<template>
  <div
    v-if="!basic && action"
    :class="classList"
    @click.prevent="onClick"
    :data-id="id">
    <span>{{ title }}</span>
    <FontIcon
      v-if="icon"
      :name="icon"
      class="float-right"
      height="14"
    />
  </div>
  <RouterLink
    v-else-if="!basic && route && exact"
    :to="route"
    :class="classList"
    exact>
    <span class="a-list-item__icon">
      <FontIcon
        v-if="listIcon"
        :name="listIcon"
        height="16"
      />
    </span>
    <span>{{ title }}</span>
  </RouterLink>
  <RouterLink
    v-else-if="!basic && route && !exact"
    :to="route"
    :class="classList">
      <span class="a-list-item__icon">
        <FontIcon :name="listIcon" v-if="listIcon" height="16" />
      </span>
    <span>{{ title }}</span>
  </RouterLink>
  <RouterLink
    v-else-if="basic && route"
    :class="classList"
    @click.prevent="onClick"
    :to="route"
    :data-id="id">
    <span>{{ title }}</span>
  </RouterLink>
  <div
    v-else-if="basic && action"
    :class="classList"
    @click.prevent="onClick"
    :data-id="id">
    <span>{{ title }}</span>
  </div>
</template>

<script>
import FontIcon from '@/components/Icon.vue';

export default {
  name: 'VListItem',
  introduction: 'Styled items for lists. To be deprecated.',
  components: {
    FontIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
      note: '',
    },
    active: {
      type: Boolean,
      default: false,
      note: '',
    },
    basic: {
      type: Boolean,
      default: false,
      note: '',
    },
    selectFirst: {
      type: Boolean,
      default: false,
      note: '',
    },
    exact: {
      type: Boolean,
      default: false,
      note: '',
    },
    listIcon: {
      type: [String, Boolean],
      default: false,
      note: '',
    },
    inverted: {
      type: Boolean,
      default: false,
      note: '',
    },
    disabled: {
      type: Boolean,
      default: false,
      note: '',
    },
    action: {
      type: Function,
      note: '',
    },
    route: {
      type: String,
      note: '',
    },
    icon: {
      type: String,
      note: '',
    },
    // TODO is ID used?
    id: {
      type: Number,
      note: '',
    },
  },
  data() {
    return {
      selected: false,
    };
  },
  computed: {
    classList() {
      const {
        active, basic, selected, inverted, disabled,
      } = this;
      return {
        'a-list-item': true,
        'a-list-item--active': active,
        'a-list-item--basic': basic,
        'a-list-item--selected': selected,
        'a-list-item--inverted': inverted,
        'a-list-item--disabled': disabled,
      };
    },
  },
  methods: {
    onClick(...args) {
      this.$emit('action', args);
      if (!this.disabled) this.action(...args);
    },
  },
};
</script>

<style scoped>
.a-list-item {
  color: initial;
  padding: var(--spacing-base);
  display: block;
  text-decoration: none;
  font-weight: bold;
  border-left: 0px solid var(--signable-secondary-2-shade-3);
  transition: 0.2s border-left ease;
}

.a-list-item--inverted {
  color: #fff;
  background: var(--signable-secondary-2);
  border-bottom: 1px solid var(--list-odd-color);
  white-space: nowrap;
}

.a-list-item--inverted:after {
  content: '';
  display: block;
  clear: both;
}

.a-list-item--inverted span:not(.a-list-item__icon) {
  line-height: 26px;
  margin-top: 3px;
  vertical-align: middle;
}

.a-list-item--inverted .a-list-item__icon {
  padding: var(--spacing-xs);
  background: #fff;
  border-radius: 30px;
  position: relative;
  height: 26px;
  width: 26px;
  display: inline-block;
  vertical-align: middle;
  margin-right: var(--spacing-small);
}

.a-list-item--inverted .a-list-item__icon svg {
  position: absolute;
  transform: translate3d(-50%, -50%, 0);
  top: 50%;
  left: 50%;
  margin: 0;
  fill: var(--signable-secondary-2-shade-2);
  width: 12px;
}

.a-list-item--inverted--active, .a-list-item--inverted.router-link-active {
  border-left: 5px solid var(--signable-secondary-2-shade-3);
  background: var(--list-odd-color);
  color: #fff;
  border-bottom: 0;
}

.a-list-item--inverted--active .a-list-item__icon, .a-list-item--inverted.router-link-active .a-list-item__icon {
  background: #fff;
}

.a-list-item--inverted--active .a-list-item__icon svg, .a-list-item--inverted.router-link-active .a-list-item__icon svg {
  fill: var(--signable-secondary-1);
}

.a-list-item--basic {
  padding: var(--spacing-small);
  cursor: pointer;
  border-top: 1px solid var(--color-border);
  background: #fff;
  font-weight: normal;
}

.a-list-item--basic:hover {
  background-color: var(--signable-secondary-3-shade-3);
}

.a-list-item--basic:first-child {
  border-top: 0;
}

.a-list-item--basic.a-list-item--selected {
  background-color: var(--signable-secondary-2-shade-3);
  color: #fff;
  font-weight: 600;
}

.a-list-item--disabled {
  pointer-events: none;
  cursor: not-allowed;
  background: var(--signable-secondary-4);
  text-decoration: line-through;
}

.a-list-item svg {
  vertical-align: text-top;
  margin-right: var(--spacing-xs);
  width: 20px;
}
</style>
